<template>
  <section class="container">
    <section class="panel center-block">
      <div class="container-fluid">
        <h1 class="sep mt-3">Règlement</h1>
        <div class="editor" v-html="REGLEMENT">
        </div><!-- EDITOR-->
        <h1 class="sep mt-3">Rgpd</h1>
        <div class="editor" v-html="RGPD">

        </div><!-- EDITOR-->
        <p class="mb-0 mt-3 error bg-danger" v-show="RgpddNotAccepted">
          * Obligatoire 
        </p>
           <label class="custom__checkbox standard mt-3" v-show="NotAccepted">
                  <input type="checkbox" v-model="AcceptRgpd" />
                  <span class="custom__checkbox__label">Je valide, comprends et accepte ces réglementations </span>
              </label>


        <p class="text-center mt-4" v-show="NotAccepted"><button class="btn btn-warning" v-on:click="Accept()"><i class="icon thumb-up-white"></i> Accepter le règlement</button></p>

        <p class="text-center mt-4" v-show="!NotAccepted"><button class="btn btn-warning" v-on:click="Retour()"> ‹‹ Retour </button></p>

      </div>
    </section><!-- PANEL -->
    <span class="panel-bottom"></span>

  </section><!-- CONTAINER FLUID-->
</template>
<script>
  import $ from 'jquery';
  import { Utility } from '../configs/configpaths';
  export default {
    data: function () {
      return {
        modalOpen_required: false,
        REGLEMENT: "",
        RGPD: "",
        AcceptRgpd:false,
        NotAccepted: false,
        RgpddNotAccepted: false
      };
    },

    mounted: function () {
      var _self = this;
      _self.$parent.GloablEvents();
      
      
      var CURRENT_USER = Utility.GetCurrent();
      var TOKEN = Utility.GetToken();
      if (!CURRENT_USER) {
        _self.$router.push('/');
      }
      var settings = {
        "async": false,
        "crossDomain": true,
        "url": _self.BASE_URL + "api/Question/Reglement",
        "data": {
          "id": _self.$route.params.id,
          "participant": CURRENT_USER.Id
        },
        "method": "GET",
        "headers": {
          'Authorization': 'Bearer ' + TOKEN
        }
      };

      $.ajax(settings).done(function (response) {
        _self.RGPD = response.Rgpd;
        _self.REGLEMENT = response.Reglement;
        _self.NotAccepted = !response.Redirected;
      }).fail(function () {
        _self.$router.push('/');

      });
    },
    methods: {
      Accept: function () {
        var _self = this;
        _self.RgpddNotAccepted=  !_self.AcceptRgpd;
        if (_self.AcceptRgpd !== true) return;
        _self.DoAccept();
       
      },
      Retour: function () {
        var _self = this;
        var response = Utility.GetCurrent();
        if (response.QuestionId === null) {
          _self.$router.push('/ListeQuestions')
          return;
        }
        _self.GoToQuestion(response.QuestionId);
      },
      DoAccept: function () {
        var _self = this;
        var CURRENT_USER = Utility.GetCurrent();
        var TOKEN = Utility.GetToken();
       
        if (!CURRENT_USER) {
          _self.$router.push('/');
        }
        var settings = {
          "async": false,
          "crossDomain": true,
          "url": _self.BASE_URL + "api/Question/AcceptReglement",
          "method": "GET",
          "headers": {
            'Authorization': 'Bearer ' + TOKEN
          }
        };
       
        $.ajax(settings).done(function () {
       
          var responseQuestion = Utility.GetCurrent();
          var id = parseInt(responseQuestion.QuestionId);
          if (responseQuestion.QuestionId === null) {
            _self.$router.push('/ListeQuestions')
            return;
          }
          if (responseQuestion.DejaJoue === true) {
            _self.$router.push('/DejaJoue/' + id);
            return;
          }
          if (responseQuestion.TypeQuestion === "ChoixUnique") { _self.$router.push('/QuestionType2/' + id); }
          if (responseQuestion.TypeQuestion === "ChoixMultiple") { _self.$router.push('/QuestionType3/' + id); }
          if (responseQuestion.TypeQuestion === "Numerique") { _self.$router.push('/QuestionType1/' + id); }
        }).fail(function () {
         
          _self.$router.push('/');

        });
      },
      GoToQuestion: function (id) {
        var _self = this;
        var CURRENT_USER = Utility.GetCurrent();
        var TOKEN = Utility.GetToken();
     
        if (!CURRENT_USER) {
        
          _self.$router.push('/');
        }
        var settings = {
          "async": false,
          "crossDomain": true,
          "url": _self.BASE_URL + "api/Question/CurrentQuestionType",
          "data": {
            "id": id
          },
          "method": "GET",
          "headers": {
            'Authorization': 'Bearer ' + TOKEN
          }
        };

        $.ajax(settings).done(function (reponse) {
          if (reponse === "ChoixUnique") { _self.$router.push('/QuestionType2/' + id); }
          if (reponse === "ChoixMultiple") { _self.$router.push('/QuestionType3/' + id); }
          if (reponse === "Numerique") { _self.$router.push('/QuestionType1/' + id); }
        }).fail(function () {
          _self.$router.push('/');

        });
      }
    }

  };
</script>
<style lang="scss" scoped>
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
